import {
  ADD_CURRENCY_PAIR,
  ADD_CURRENCY_PAIR_SUCCESS,
  ADD_CURRENCY_PAIR_FAILURE,
  UPDATE_CURRENCY_PAIR,
  UPDATE_CURRENCY_PAIR_SUCCESS,
  UPDATE_CURRENCY_PAIR_FAILURE,
  FETCH_CURRENCY_PAIRS,
  FETCH_CURRENCY_PAIRS_SUCCESS,
  FETCH_CURRENCY_PAIRS_FAILURE,
  DELETE_CURRENCY_PAIR,
  DELETE_CURRENCY_PAIR_SUCCESS,
  DELETE_CURRENCY_PAIR_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  pairs: [],
  loading: false,
  error: null,
};

const currencyPairsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Add Currency Pair
    case ADD_CURRENCY_PAIR:
      return { ...state, loading: true, error: null };
    case ADD_CURRENCY_PAIR_SUCCESS:
      return {
        ...state,
        pairs: [...state.pairs, action.payload],
        loading: false,
        error: null,
      };
    case ADD_CURRENCY_PAIR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Update Currency Pair
    case UPDATE_CURRENCY_PAIR:
      return { ...state, loading: true, error: null };
    case UPDATE_CURRENCY_PAIR_SUCCESS:
      return {
        ...state,
        pairs: state.pairs.map((pair) =>
          pair._id === action.payload._id ? action.payload : pair
        ),
        loading: false,
        error: null,
      };
    case UPDATE_CURRENCY_PAIR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch Currency Pairs
    case FETCH_CURRENCY_PAIRS:
      return { ...state, loading: true, error: null };
    case FETCH_CURRENCY_PAIRS_SUCCESS:
      return {
        ...state,
        pairs: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_CURRENCY_PAIRS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Delete Currency Pair
    case DELETE_CURRENCY_PAIR:
      return { ...state, loading: true, error: null };
    case DELETE_CURRENCY_PAIR_SUCCESS:
      return {
        ...state,
        pairs: state.pairs.filter((pair) => pair._id !== action.payload),
        loading: false,
        error: null,
      };
    case DELETE_CURRENCY_PAIR_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default currencyPairsReducer;